export const size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    mobileXL: '500px',
    tablet: '768px',
    laptop: '1024px',
    desktop: '1280px',
};

export const mediaQuery = {
    lessMobileS: `@media (max-width: ${size.mobileS})`,
    mobileS: `@media (min-width: ${size.mobileS})`,
    mobileM: `@media (min-width: ${size.mobileM})`,
    mobileL: `@media (min-width: ${size.mobileL})`,
    mobileXL: `@media (min-width: ${size.mobileXL})`,
    tablet: `@media (min-width: ${size.tablet})`,
    laptop: `@media (min-width: ${size.laptop})`,
    desktop: `@media (min-width: ${size.desktop})`,
};
